import gql from 'graphql-tag';
import { Nullable } from 'global';
import { PrescreenCriteria } from '@trnsact/trnsact-shared-types';
import { ScoreTierEntity } from './types';

export const GET_SCORECARD = gql`
  query GetScoreCardConfiguration {
    scoreCard {
      accountId
      financeProgramId
      structure
      createdDateTime
      modifiedDateTime
      prescreenCriteria {
        active
        accountId
        jsonCriteria
        prescreenCriteriaId
      }
    }
  }
`;

export const CREATE_SCORECARD = gql`
  mutation CreateScorecard($input: CreateScoreCardInput!) {
    createScoreCard(input: $input) {
      financeProgramId
      prescreenCriteria {
        prescreenCriteriaId
      }
    }
  }
`;

export const UPDATE_SCORECARD = gql`
  mutation UpdateScorecard($input: UpdatePrescreenCriteriaInput!) {
    updatePrescreenCriteria(input: $input) {
      prescreenCriteriaId
    }
  }
`;

export const UPDATE_CRITERIA_STATUS = gql`
  mutation UpdateCriteriaStatus($input: UpdateFinanceProgramInput!) {
    updateFinanceProgram(input: $input) {
      nameInternal
    }
  }
`;

export interface ScorecardCriteria extends Omit<PrescreenCriteria, 'jsonCriteria'> {
  jsonCriteria: {
    scoreCriteria: ScoreCriteriaJSON[];
    scoreTiers: ScoreTierEntity[];
  };
}

export interface ScoreCriteriaJSON {
  criteria: Record<string, any>;
  customCriteria?: Record<string, any>;
  formRules: Record<string, any>[];
  jsonRules: {
    conditions: {
      all: any[];
    };
  };
}

export interface ScorecardCreateVariables {
  input: {
    nameInternal: string;
    validDateStart: null;
    validDateEnd: null;
    financeProgramModificationSettings: { markup: false };
    prescreenCriteriaInput: {
      name: string;
      notes: Nullable<string>;
      guidelines: Nullable<string>;
      lenderProfileIdsToLink: any[];
      financeProgramIdsToLink: any[];
      jsonCriteria: {
        scoreCriteria: ScoreCriteriaJSON[];
        scoreTiers: ScoreTierEntity[];
      };
    };
  };
}

export interface ScorecardUpdateVariables {
  input: {
    prescreenCriteriaId: string;
    accountId: string;
    jsonCriteria: any;
  };
}

export interface UpdateCriteriaStatusVariables {
  input: {
    active: boolean;
    financeProgramId: string;
  };
}
